import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img23 from "../../About/images/23.JPG";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person23 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img23} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Жалмагамбетова Ултуар Каирбулатовна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        PhD Thermal Power Engineering, Master of Technical Sciences (Automation and Control), Electrical Engineer
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57202369438'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0002-2261-2222'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        НАО «Торайгыров университет», старший научный сотрудник, ассоциированный профессор кафедры «Электротехники и автоматизации», заместитель декана по научной работе факультета энергетики
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Старший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на основных стационарных источниках эмиссий с использованием облачных технологий или промышленного интернета вещей.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участник с опытом более 25 лет в сфере энергетики, автоматизации и математического моделирования. Публикации, производственный опыт, владение MatLab, AutoCAD, знание электроники, электротехники. Выполняет анализ литературы, подготовку статей, разработку и проведение экспериментов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте программно-целевого финансирования на 2024-2026 гг. ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений, обеспечивая эффективное использование трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». Роль –исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований, написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры программного комплекса;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на стационарные источники эмиссий с использованием облачных технологий или IIoT.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Neftissov A. et al. Analysis of the Existing Air Emissions Detection Methods. Appl. Sci. 2024, 14, 10934. DOI: https://doi.org/10.3390/app142310934 (Scopus Q1)
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Zhalmagambetova U. et al. Implications of Water Quality Index and Multivariate Statistics. Water 2024, 16, 2203. DOI: https://doi.org/10.3390/w16152203
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Zhalmagambetova U. et al. Environmental monitoring in Kazakhstani context. Вестник Торайгыров университета. №1, 2024. С. 82–93. DOI: https://doi.org/10.48081/MOFF1407
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    4. Zhalmagambetova U. et al. Development of an automatic monitoring system. Вестник Торайгыров университета. №2, 2024. С. 112–125. DOI: https://doi.org/10.48081/BMOM3785
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    5. Жалмагамбетова У.К. и др. Методы определения эмиссий. Вестник Торайгыров университета. №3, 2024. С. 167–180. DOI: https://doi.org/10.48081/HRWJ4394
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    6. Жалмагамбетова У.К. и др. Обзор технологий мониторинга в энергетике. Вестник Торайгыров университета. №4, 2024. С. 208–220. DOI: https://doi.org/10.48081/LTKA1105
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    7. Жалмагамбетова У.К. и др. Проектирование систем передачи информации. Вестник Торайгыров университета. №1, 2025. С. 108–120. DOI: https://doi.org/10.48081/WNUU3720
                </MyText>
            </Flex>
        </Flex>
    );
}